import styled from 'styled-components'

export const MobileLanguageChangeStyleWrapper = styled.div`
  display: none;
  position: absolute;
  bottom: 0;
  padding: 40px 30px;
  & > ul {
    display: flex;
    & > li:not(:last-child) {
      margin-right: 24px;
    }
  }
  .flag-container {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    opacity: 0.5;
    & > img {
      width: 100%;
      height: 100%;
    }
  }
  .flag-container.active {
    opacity: 1;
  }
  @media (max-width: 800px) {
    display: block;
  }
`